<template>
  <div>
    <div class="tw-flex tw-justify-between tw-my-4">
      <div>
      

        <vs-select
            label="Sayfada Gösterilecek Kayıt Sayısı"
            v-model="pageSize"
            @change="handlePageSizeChange"
        >
          <vs-select-item
              v-for="size in pageSizes"
              :key="size"
              :value="size"
              :text="size"
          />
        </vs-select>
      </div>

      <vs-paginator
          v-if="meta"
          :meta="meta"
          @change="handlePageChange"
      ></vs-paginator>

    </div>

    <vs-table stripe :data="list">
      <template slot="header">
        <div class="tw-w-full tw-flex tw-items-center tw-justify-between">
          <h3>Son Sorgular</h3>
          <vs-button
              radius
              size="small"
              color="warning"
              type="border"
              icon="mdi-cached"
              @click="page = 1; get();"
          >
          </vs-button>
        </div>
      </template>
      <template slot="thead">
       
        <vs-th>Tarih</vs-th>
        <vs-th>Aranan Terim</vs-th>
        <vs-th>Sorgu</vs-th>
        <vs-th>Erişim Sayfası</vs-th>
       
      </template>
      <template slot-scope="{data}">
        <vs-tr v-for="(item, i) in data" :key="i" >
          <vs-td>
            {{ i + 1 }}.
          </vs-td>
          <vs-td>
            <div>{{ formatDate(item.createdAt) }}</div>
            <small class="tw-ml-1 tw-italic">~ {{ formatDateInterval(item.createdAt) }}</small>
          </vs-td>
          <vs-td :data="item.term">
            <div>{{ item.term }}</div>
          </vs-td>
          <vs-td :data="item.query_string">
            <div>{{ item.query_string }}</div>
          </vs-td>
          <vs-td :data="item.url">
            <div>{{ 
            (item.url =="/appeals") ? "Etkinlik Kayıt" :
              (item.url =="/home") ? "Anasayfa" :
              (item.url =="/appeals/create") ? "Etkinlik Kayıt Oluşturma" :
              (item.url =="/informations") ? "Etkinlik Bilgileri" :
              (item.url =="/informations/create") ? "Etkinlik Bilgileri Ekleme" :
               (item.url =="/finishevent") ? "Etkinlik Bitir" :
                (item.url =="/ends") ? "Etkinlik Sonrası" :
                  (item.url =="/surveys") ? "Etkinlik Anketleri" :
                 (item.url =="/FolderManagement") ? "Etkinlik Dosya Yönetimi" :
                 (item.url =="/MyActivities") ? "Etkinliklerim" :
               (item.url =="/prequest") ? "Dilek Şikayet" :
               (item.url =="/dashboard") ? "Rapor Ekranı" :
               (item.url =="/analytics") ? "Log Ekranı" :
               (item.url =="/users") ? "Kullanıcı Yetki Düzenleme" :
                 (item.url =="/users/create") ? "Kullanıcı Oluşturma" :
                 (item.url =="/login") ? "Login" : 
                 (item.url =="/institutions") ? "Kurum Onay Sayfası(admin)" : 
                 (item.url =="/rooms") ? "Salon Onay Sayfası(admin)" : 
                 (item.url =="/events") ? "Etkinlik Türü Onay Sayfası(admin)" : 
                 (item.url =="/etkinlikbitir") ? "Etkinlik Bitir" : 
                  (item.url =="/profile") ? "Profil Sayfası" : 


               item.url 
            
            }}</div>
            <small>{{ item.domain }}</small>
          </vs-td>
          
        </vs-tr>
      </template>
    </vs-table>
  </div>
</template>

<script>
  import { analyticsMixin } from "@/libs/analytics/analyticsMixin";

  export default {
    name: "Analytics-Queries",
    title: "Analitik - Sorgular",

    mixins: [
      analyticsMixin,
    ],

    data() {
      return {
        decoratorKey: 'queries',
      }
    },

    methods: {

    }
  }
</script>

<style scoped>

</style>